export default __webpack_public_path__ + "static/media/step6.f033e9d5.png";